import {
  REMOVE_ADDON_BY_STRIPE_ID,
  ENABLE_ADDON_PRICE_IF_REQUIRED,
  SET_ADDON_PRICE,
  SET_RESALE_ADDONS,
  SET_ERRORS,
  CLEAR_ADDON_CONFIGURATION,
} from "./constants";
import {writeAddonsToSession, isAddonPriceRequired} from "./methods";
import {formatPriceInput} from "../../sharedGlobal";
import _ from "lodash";

/**
 * Set the price of a user created addon.
 */
export function setAddonPrice(state, {stripeId, price}) {
  delete state.errors[`addons.${stripeId}`];
  state.addons[stripeId] = price * 100;
  writeAddonsToSession(state.addons);
}

/**
 * Enable a user-created addon, only if required.
 * TODO: Revisit "if required" it seems to be regardless?
 */
export function enableAddonPriceIfRequired(
  state,
  {
    supportedCurrencies,
    softwarePrices,
    resaleAddonPrice,
  }
) {
  if (isAddonPriceRequired(supportedCurrencies, softwarePrices, resaleAddonPrice)) {
    state.addons = {
      ...state.addons,
      [resaleAddonPrice.stripe_id]: 0,
    };
  }
  writeAddonsToSession(state.addons);
}

/**
 * Remove a user-created addon by the stripe price id it relates to.
 */
export function removeAddonByStripeId(state, stripeId) {
  delete state.addons[stripeId];
  writeAddonsToSession(state.addons);
}

/**
 * Set the errors object.
 * TODO: Dedupe across product/addon manager
 */
function setErrors(state, { errors, namespace, joi }) {
  let newErrors = errors;

  if (joi === true) {
    // Flattening the Joi error format into dot-notation keyed errors
    newErrors = errors.reduce((total, e) => {
      const { message, path } = e;
      path.unshift(namespace);
      total[path.join('.')] = message;
      return total;
    }, state.errors);

    return;
  }

  state.errors = newErrors;
}

export default {
  [SET_ADDON_PRICE]: setAddonPrice,
  [SET_RESALE_ADDONS]: (state, payload) => state.resaleAddons = payload,
  [REMOVE_ADDON_BY_STRIPE_ID]: removeAddonByStripeId,
  [ENABLE_ADDON_PRICE_IF_REQUIRED]: enableAddonPriceIfRequired,
  [SET_ERRORS]: setErrors,
  [CLEAR_ADDON_CONFIGURATION]: (state) => {
    state.addons = {};
    writeAddonsToSession(state.addons);
  },
};
